import { useVendorCategoriesList } from "api/vendor";
import CustomReactSelect from "components/CustomReactSelect";
import PropTypes from "prop-types";
import { useCallback, useMemo } from "react";


const VendorCategorySelector = ({
    value,
    onChange,
    label = "Vendor Category",
    placeholder = "Select Category...",
    isMulti = false,
    required = false,
    disabled = false,
    ...props
}) => {
    const vendorCategoryQuery = useVendorCategoriesList({ get_all: true });

    const vendorCategories = useMemo(
        () => (vendorCategoryQuery.data ?? []).map(vendorCategory => ({
            label: vendorCategory,
            value: vendorCategory,
        })),
        [vendorCategoryQuery.data]
    );

    const handleFetch = useCallback(async (inputValue = "") => {
        const normalizedInput = inputValue.trim().toLowerCase();
        if (!normalizedInput) {
            return vendorCategories;
        }

        return vendorCategories.filter(option => option.label.toLowerCase().includes(normalizedInput));
    }, [vendorCategories]);

    const getSelectedValue = () => {
        if (!value) return null;
        if (isMulti) {
            return vendorCategories.filter(option => value.includes(option.value)) || null;
        }
        return vendorCategories.find(option => option.value === value) || null;
    };

    const handleChange = (selectedOption) => {
        if (isMulti) {
            const selectedValues = selectedOption ? selectedOption.map(opt => opt.value) : [];
            if (onChange) {
                onChange(selectedValues, selectedOption);
            }
        } else {
            const selectedValue = selectedOption ? selectedOption.value : null;
            if (onChange) {
                onChange(selectedValue, selectedOption);
            }
        }
    };


    return (
        <CustomReactSelect
            label={label}
            isMulti={isMulti}
            isClearable
            cacheOptions={true}
            loadOptions={handleFetch}
            value={getSelectedValue()}
            options={vendorCategories}
            onChange={handleChange}
            placeholder={placeholder}
            required={required}
            disabled={disabled}
            noOptionsMessage={() => "No vendor categories found"}
            {...props}
        />
    );
};

VendorCategorySelector.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object,
        PropTypes.string,
        PropTypes.number,
    ]),
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    isMulti: PropTypes.bool,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default VendorCategorySelector;